module.exports = __webpack_public_path__ + "img/activity21.aeb56bdd.jpg";